import { ReactNode } from 'react';

interface ProductListEmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

const ProductListEmptyState = ({
  icon,
  title,
  description,
  action,
}: ProductListEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-3 py-20 text-center">
    {icon && (
      <div className="text-gray-400" aria-hidden="true">
        {icon}
      </div>
    )}
    <h3 className="text-base font-semibold text-gray-900">{title}</h3>
    {description && <p className="max-w-md text-sm text-gray-600">{description}</p>}
    {action && <div className="mt-2">{action}</div>}
  </div>
);

export default ProductListEmptyState;
